import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({data}) => setStats(data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow mb-2">Platform admin</div>
        <h1 className="page-title">System overview</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {stats && Object.entries(stats).map(([k,v]) => (
          <div key={k} className="surface p-4 md:p-5" data-testid={`admin-stat-${k}`}>
            <div className="text-[11px] uppercase tracking-wider text-slate-500">{k.replace(/_/g,' ')}</div>
            <div className="text-2xl md:text-3xl font-semibold tracking-tight mt-2 tabular-nums">{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
